import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseDraggableWidget } from '../Card';

import useAsync from '../../../hooks/useAsync';
import useModal from '../../../hooks/useModal';

import { searchContacts } from '../../../api/contacts';

import { classNames, getUserFullName } from '../../helpers/functions';

import { TemplateField } from '../../Attributes/Attributes_old';
import { AvatarGenerated } from '../../Avatar';

const VendorSearch = ({ title, isPreview, ...rest }) => {
	const [query, setQuery] = useState('');

	const navigate = useNavigate();
	const { setOpen: openContactModal } = useModal('viewContact');

	const {
		value: contacts,
		execute: onRefreshVendors,
		resetValue,
		status: isLoadingVendors,
	} = useAsync(searchContacts, { immediate: false });

	useEffect(() => {
		if (query) {
			const delayDebounceFn = setTimeout(
				() => {
					onRefreshVendors({ query, limit: 5 });
				},
				query ? 600 : 0
			);

			return () => clearTimeout(delayDebounceFn);
		} else {
			resetValue();
		}
	}, [query]);

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title="Vendor Search"
				category="System"
				description={'Quickly search for vendors by name, company, or asset'}
				{...rest}
				isPreview={true}
			/>
		);
	}

	return (
		<BaseDraggableWidget
			title="Vendor Search"
			widgetProps={{
				fullHeight: true,
				additonalMenuItems: [
					{
						name: 'View all vendors',
						onClick: () => navigate('/manage/directory'),
					},
				],
			}}
			{...rest}
		>
			<>
				<TemplateField
					placeholder="Search by vendor name, company, or assigned asset"
					value={query}
					onChange={(index, search) => setQuery(search)}
				/>

				{isLoadingVendors === 'pending' || !contacts ? (
					<div class="flex flex-col justify-center flex-1 h-full items-center -mt-4 text-gray-400">
						Type to search
					</div>
				) : query?.length ? (
					contacts?.length ? (
						<div className="mt-3">
							{contacts?.length
								? contacts?.map((contact) => {
										return (
											<div
												className={classNames('py-2 cursor-pointer pl-6 ')}
												onClick={() => openContactModal({ id: contact?.id })}
											>
												<div className="flex items-center">
													<div>
														{contact?.type === 'person' && (
															<AvatarGenerated
																size="xs"
																id={getUserFullName(contact)}
															/>
														)}
														{contact?.type === 'company' && (
															<AvatarGenerated
																size="xs"
																id={contact.id}
																type="company"
															/>
														)}
													</div>

													<div className="flex-1 ml-3">
														<div>
															<span className="font-semibold">
																{contact?.type === 'company'
																	? contact?.companyName
																	: getUserFullName(contact)}
															</span>
														</div>

														<div className="text-gray-400 text-xxs">
															{contact?.type === 'company'
																? 'Company'
																: `${
																		contact?.title
																			? `${contact?.title}${
																					contact?.company?.companyName
																						? ` from ${contact?.company?.companyName}`
																						: ''
																			  }`
																			: contact?.company?.companyName
																			? contact?.company?.companyName
																			: ''
																  }`}
														</div>
													</div>
												</div>
											</div>
										);
								  })
								: []}
						</div>
					) : (
						<div class="flex flex-col justify-center flex-1 h-full items-center -mt-4 text-gray-400">
							No vendors found
						</div>
					)
				) : (
					<div class="flex flex-col justify-center flex-1 h-full items-center -mt-4 text-gray-400">
						Type to search
					</div>
				)}
			</>
		</BaseDraggableWidget>
	);
};

export default VendorSearch;
